
import { SYSTEM_MESSAGE_METADATA } from './system-message.metadata';
import { SystemMessageBase } from './system-message.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface SystemMessage extends SystemMessageBase {
}

export interface SystemMessageTransient { }

export class SystemMessage extends CrudEntity<SystemMessage, number, SystemMessageTransient> implements SystemMessageTransient {
  constructor(source?: Partial<SystemMessage>, options?: CrudEntityConstructionOptions<SystemMessage, number, SystemMessageTransient>) {
    super(SYSTEM_MESSAGE_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





